(ns rothko.editor.edit.transform
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.edit.paths :as edit-paths]))

(defn create-edit
  [index word]
  [(sp/before-index index)
   (sp/terminal-val
    {:word word
     :type :edit})])

(defn insert-char
  [index start-offset end-offset chars]
  [(sp/nthpath index)
   :word
   (sp/srange start-offset end-offset)
   (sp/terminal-val chars)])

(def
  ^{:doc "Removes all (space-)edit tokens from the selection and shrinks it
  accordingly. Also removes `:edited?` key from the selected tokens. System
  annotation is unaffected."}
  remove-all
  (n/remove-all
   [(complement :system?)
    edit-paths/EDIT-OR-SPACE-EDIT?]
   [(sp/selected? (complement :system?))
    :edited?]))
